// src/hooks/useCompanies.js
import { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";

export default function useCompanies() {
  const [companyNames, setCompanyNames] = useState([]);
  const [allCompanies, setAllCompanies] = useState({});
  const db = getDatabase();

  useEffect(() => {
    const companiesRef = ref(db, "/companies/");
    const unsubscribe = onValue(companiesRef, (snapshot) => {
      const companiesData = snapshot.val();
      if (companiesData) {
        const visibleCompanies = Object.entries(companiesData)
          .filter(([_, companyData]) => companyData.isCompanyVisible === true)
          .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {});

        setCompanyNames(Object.keys(visibleCompanies));
        setAllCompanies(visibleCompanies);
      }
    });

    return () => unsubscribe();
  }, [db]);

  return { companyNames, allCompanies };
}
